<template>
    <button class="ds-btn px-4 py-2" :class="{'ds-btn--disabled': isLoading}" type="submit">
        <div v-if="isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <span v-else>{{ btnText }}</span>
    </button>
</template>
<script>
    export default {
        props: {
            btnText: {
                type: String,
                required: true,
            },
            isLoading: {
                type: Boolean,
                required: true,
            }
        }
    }
</script>